import React from 'react'
import DimensionsFilter from './dimensions-filter'
import NameFilter from './name-filter'
import ResourceTypesFilter from './resource-types-filter'
import LabeledInput from '../../common/labeled-input'
import useViewport from '../../../hooks/use-viewport'

const LearningResourcesFilters = () => {

    const { isMobile } = useViewport()

    if(isMobile) {
        return (
            <React.Fragment>
                <NameFilter />
                <div style={{paddingBottom: '15px'}}><DimensionsFilter /></div>
                <ResourceTypesFilter />
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <LabeledInput>
                <NameFilter />
            </LabeledInput>
            <LabeledInput label='Wellness Dimensions'>
                <DimensionsFilter />
            </LabeledInput>
            <LabeledInput label='Resource Type'>
                <ResourceTypesFilter />
            </LabeledInput>
        </React.Fragment>
    )
}

export default LearningResourcesFilters